import React from 'react';

import Text from 'components/shared/text';
import Container from 'components/shared/container';
import CssImplementation from 'components/shared/css-implementation';

const PropertyBasicExample = ({ property }) => {
  let displayedProperty = [
    { name: property?.name, value: property?.tagHelper?.propertyValue },
  ];

  return (
    <Container>
      <Text
        margin="0"
        width="100%"
        fontSize="18px"
        textAlign="left"
        fontWeight="bold"
        text="Basic Example"
      />
      <Text
        width="100%"
        textAlign="left"
        margin="20px 0"
        text="Below is a basic example of the property."
      />
      <CssImplementation
        idForCopy="css-rule-example"
        properties={property?.tagHelper?.properties}
        selectorName={property?.tagHelper?.selector}
      />
    </Container>
  );
};

export default PropertyBasicExample;
